import { render, staticRenderFns } from "./EmailUserModal.vue?vue&type=template&id=72076bea&scoped=true&"
import script from "./EmailUserModal.vue?vue&type=script&lang=js&"
export * from "./EmailUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72076bea",
  null
  
)

export default component.exports